import React, { useCallback, useState } from 'react'
import Modal, { ModalBody, ModalHeader, ModalTitle, ModalFooter } from '../../bootstrap/Modal';
import Button from '../../bootstrap/Button';
import Spinner from '../../bootstrap/Spinner';
import showNotification from '../../extras/showNotification';
import api from '../../../services/api';

const _messageDeleteSuccess = (
  <div>
    <p>
      Terminal deletado com sucesso!
    </p>
  </div>
);

const ModalDeleteTerminal = ({ open, setIsOpen, setIsClose, terminalSerial }) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleDelete = useCallback(async () => {
    if (!terminalSerial) return;
    setIsLoading(true);
    await api
      .delete('/terminal', { data: { serial: terminalSerial } })
      .then(() => {
        showNotification('', _messageDeleteSuccess, 'success');
      })
      .catch((error) => {
        const reason =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.code ||
          error?.message ||
          '';
        showNotification('', (
          <div>
            <p>Erro ao deletar terminal! {reason}</p>
          </div>
        ), 'danger');
      })
      .finally(() => {
        setIsLoading(false);
        setIsClose();
      });
  }, [terminalSerial, setIsClose]);

  return (
    <Modal
      id={'modal-delete-terminal'}
      titleId={'Exclusão de Terminal'}
      isOpen={open}
      setIsOpen={setIsOpen}
      isStaticBackdrop={true}
      isScrollable={false}
      isCentered={true}
      size="lg"
      isAnimation={true}
    >
      <ModalHeader setIsOpen={setIsOpen}>
        <ModalTitle id="user">Exclusão de Terminal</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <p>Você está excluindo um Terminal. Está ação é irrevesível. Deseja continuar?</p>
      </ModalBody>
      <ModalFooter>
        <Button
          color="danger"
          icon="cancel"
          rounded={1}
          onClick={setIsClose}
          shadow="sm"
          hoverShadow="sm"
          size="sm"
        >
          Cancelar
        </Button>
        {isLoading ? (
          <Button
            color="success"
            rounded={1}
            hoverShadow="sm"
            shadow="sm"
            size="sm"
          >
            <Spinner
              color="light"
              inButton
              isGrow
              isSmall
              size={10}
              tag="span"
            >
              Carregando...
            </Spinner>
            Carregando...
          </Button>
        ) : (
          <Button
            type='submit'
            color='success'
            icon="check"
            rounded={1}
            hoverShadow="sm"
            shadow="sm"
            size="sm"
            isDisable={!terminalSerial}
            onClick={handleDelete}
          >
            Confirmar
          </Button>
        )}
      </ModalFooter>
    </Modal>
  )
}

export default ModalDeleteTerminal
